



















































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyForm from "@/mixins/form";

import Video from "@/components/video.vue";

import BpSubmitDialog from "./bp-submit-dialog.vue";

@Component({
  components: {
    Video,
    BpSubmitDialog
  }
})
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  hasData: boolean = false;

  videoModalVisible: boolean = false;
  videoUrl: string = "";

  fields: any[] = [];

  submitDialogVisible: boolean = false;

  showSubmitDialog() {
    this.submitDialogVisible = true;
  }

  hideSubmitDialog() {
    this.submitDialogVisible = false;
  }

  showVideoModal(url: string) {
    this.videoUrl = url;
    this.videoModalVisible = true;
  }

  hideVideoModal() {
    this.videoModalVisible = false;
  }

  async loadFields() {
    const res = await this.$store.dispatch("bp/fields", {});
    // console.log(res);
    if (res && res.Data) {
      this.fields = res.Data;
    }
  }

  async loadSubmitData() {
    this.spinLoading = true;
    const res = await this.$store.dispatch("bp/wjSubmitDetail", {
      stadium_id: this.stadiumId
    });

    this.spinLoading = false;

    // console.log(res);
    if (res && res.Data) {
      this.hasData = true;
      this.formData = res.Data;
    } else {
    }
  }

  async mounted() {
    await this.loadFields();

    await this.loadSubmitData();
  }

  async selectBpSubmit(obj: any) {
    // console.log(obj);
    if (obj) {
      const res = await this.$store.dispatch("bp/bindData", {
        stadium_id: this.stadiumId,
        submit_id: obj.id
      });
      if (res && res.Message && res.Message === "success") {
        this.$message.success("操作成功");
        this.hideSubmitDialog();
        await this.loadFields();

        await this.loadSubmitData();
      } else {
        this.$message.error(res.Message);
      }
    }
  }

  handleUnbindData() {
    this.showTsConfirm({
      title: "确认信息",
      content: "你确定要解除关联吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("bp/unbindData", {
          stadium_id: this.stadiumId
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success(res.Message);

          // this.loadFields();
          this.hasData = false;
          await this.loadFields();

          await this.loadSubmitData();
        }
      }
    });
  }
}
